import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type OrderOptionCardProps = {
  title: string;
  description: string;
  image?: ReactNode;
  link: string;
  onClick?: () => void;
};

const OrderOptionCard = ({ title, description, image, link, onClick }: OrderOptionCardProps) => {
  return (
    <Link className='flex flex-col' to={link} onClick={onClick}>
      <div className='bg-gray-16 rounded-[10px] p-5 flex items-start gap-5 flex-1'>
        <div>
          <p className='font-semibold text-xl'>{title}</p>
          <p className='text-sm font-normal text-gray-12'>{description} </p>
        </div>
        <div className='self-center flex items-center'>{image}</div>
      </div>
    </Link>
  );
};

export default OrderOptionCard;
